// extracted by mini-css-extract-plugin
module.exports = {"textArea":"BannedWordListConfig-textArea-3ba4424e536d273cf80424c221924191"};